import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Form, Input, message } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addFile, deleteFile } from "../../../../../controller/services/common";
import { sendHelpRequest } from "../../../../../controller/services/settings";
import useFormValidation from "../../../../../hooks/useFormValid";
import i18n from "../../../../../localization/i18n";
import { setLoading } from "../../../../../redux/slices/common_slice";
import RightSideSettingsWrapper from "../../rightside-details-settings/RightSideSettingsWrapper";

const HelpAndSupports = () => {
  const [form] = Form.useForm();
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileUrl, setFileUrl] = useState("");
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector((state) => state?.user?.userData);
  const formUser = useSelector((state) => state.form.userData);
  const emailId = "butterfly@creditcanada.com";
  const phoneNo = "1 (800) 267-2272";
  const { handleValuesChange, formValues } = useFormValidation(form);
  const handleEmailClick = () => {
    window.location.href = `mailto:${emailId}`;
  };
  const handlePhoneNumberClick = () => {
    window.location.href = `tel:${phoneNo}`;
  };
  const handleUploadClick = () => {
    document.getElementById("fileInput").click();
  };
  const handleFileUpload = (event) => {
    const file = event?.target?.files && event?.target?.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      dispatch(setLoading(true));
      addFile(formData)
        .then((resp) => {
          message.success(resp?.message?.[i18n.language]);
          setSelectedFile(file);
          setFileUrl(resp.data.fileUrl);
        })
        .catch((err) => {
          message.error(err.message[i18n.language]);
        })
        .finally(() => {
          dispatch(setLoading(false));
        });
    }
  };

  const handleFileDelete = () => {
    dispatch(setLoading(true));
    deleteFile({ fileUrl: fileUrl })
      .then((resp) => {
        message.success(resp?.data?.message?.[i18n.language]);
        setSelectedFile(null);
        setFileUrl("");
      })
      .catch((err) => {
        message.error(err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
  const onFinish = (values) => {
    let payload;
    if (fileUrl) {
      payload = {
        description: values.description,
        attachments: fileUrl,
      };
    } else {
      payload = {
        description: values.description,
      };
    }
    dispatch(setLoading(true));
    sendHelpRequest(payload)
      .then((resp) => {
        message.success(resp?.message?.[i18n.language]);
        form.setFieldsValue({
          description: "",
        });
        setSelectedFile(null);
        setFileUrl("");
      })
      .catch((err) => {
        message.error(err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
  return (
    <RightSideSettingsWrapper>
      <Form
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
        form={form}
        onValuesChange={handleValuesChange}
        className="common-input-form"
      >
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-sl-6 col-lg-6">
            <div className="row mx-0 help-support-card">
              <div className="col-12">
                <div className="help-support-icon">
                  <img
                    src="/assets/images/icons/email-help-support-img.svg"
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div
                  className="help-support-details"
                  onClick={handleEmailClick}
                >
                  <h6>{t("settings.help&support.1")}</h6>
                  <h5 className="mb-0">{emailId}</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-sl-6 col-lg-6">
            <div className="row mx-0 help-support-card">
              <div className="col-12">
                <div className="help-support-icon">
                  <img
                    src="/assets/images/icons/contact-help-support-icon.svg"
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div
                  className="help-support-details"
                  onClick={handlePhoneNumberClick}
                >
                  <h6>{t("settings.help&support.2")}</h6>
                  <h5 className="mb-0">1 (800) 267-2272</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row query-row">
          <div className="col-12">
            <h5>{t("settings.help&support.3")}</h5>
            <div className="row">
              <div className="col-12">
                <Form.Item
                  name="name"
                  initialValue={`${
                    user.firstName || formUser?.firstName || ""
                  }`}
                >
                  <Input placeholder="Enter Your Name" readOnly />
                </Form.Item>
              </div>
              <div className="col-12">
                <Form.Item name="email" initialValue={user.email}>
                  <Input placeholder="Enter Email address" readOnly />
                </Form.Item>
              </div>
              <div className="col-12">
                <Form.Item
                  name="description"
                  rules={[
                    { required: true, message: "Please enter a description!" },
                  ]}
                >
                  <Input.TextArea
                    rootClassName="custom-description"
                    placeholder={t("settings.help&support.4")}
                    autoSize={{ minRows: 3, maxRows: 6 }}
                  />
                </Form.Item>
              </div>

              <div className="col-12 px-3 upload-details">
                {!selectedFile && (
                  <div
                    onClick={handleUploadClick}
                    className="upload-details-card"
                  >
                    <UploadOutlined
                      style={{ fontSize: "20px", marginRight: "5px" }}
                    />
                    {t("settings.help&support.5")}
                  </div>
                )}
                {selectedFile && (
                  <div className="upload-details-card upload-successfully">
                    Attachment:&nbsp;
                    {selectedFile?.name}
                    <DeleteOutlined
                      style={{
                        color: "red",
                        cursor: "pointer",
                        marginLeft: "10px",
                      }}
                      onClick={handleFileDelete}
                    />
                  </div>
                )}
                <input
                  id="fileInput"
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileUpload}
                  accept="image/*,application/pdf"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row mx-0 footer-settings-row">
          <Button
            type="primary"
            htmlType="submit"
            disabled={!formValues?.description}
          >
            {t("settings.help&support.6")}
          </Button>
        </div>
      </Form>
    </RightSideSettingsWrapper>
  );
};

export default HelpAndSupports;
